"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _SttButton = _interopRequireDefault(require("./SttButton"));
var _SaveOutlined = _interopRequireDefault(require("@material-ui/icons/SaveOutlined"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function SttSaveButton(props) {
  var _props$nomarginleft;
  return /*#__PURE__*/_react["default"].createElement(_SttButton["default"], _extends({}, props, {
    type: props.type || "submit",
    variant: props.variant || "contained",
    color: props.color || "primary",
    onClick: props.onClick || null,
    startIcon: /*#__PURE__*/_react["default"].createElement(_SaveOutlined["default"], null),
    disabled: props.disabled,
    nomarginleft: (_props$nomarginleft = props.nomarginleft) !== null && _props$nomarginleft !== void 0 ? _props$nomarginleft : "true"
  }), props.children || props.descricao || 'Salvar');
}
var _default = SttSaveButton;
exports["default"] = _default;